import ApiServices, {SUB_MCH_STATE_QUERY} from "../config/ApiServices";
import api from "../utils/api";
import {ID_CARD_VALID_TIME_SHORT, ID_CARD_VALID_TIME_FOREVER} from '../config/IdCardValidTimeType';
import store from "../store";
import {setSubMerchantMaterialInfo} from "../store/merchant";
import _ from "lodash";
import {
    ACCOUNT_NEED_VERIFY,
    AUDITING,
    CHECKING,
    FINISHED,
    NEED_SIGN, PARAM_ERROR, REJECTED, SUBMIT_TO_PLATFORM,
    WAIT_SUBMIT
} from "../config/wxSubMchApplicationStatus";
import {
    CONTRACT_INTERVIEW,
    SIGNED,
    SUBMIT_MATERIAL,
    WX_ACCOUNT_VERIFY, WX_PASSED,
    WX_REFUSED
} from "../pages/merchant/wechatSubMchApplicationStep";
import Regions from "../utils/region.json";

export class WxSubMchStateQueryEvent {
    params = {};

    constructor (params = null) {
        this.params = params;
    }

    static getEventName () {
        return 'WxSubMchStateQueryEvent';
    }
}

export class WxSubMchStateQueryListener {
    dispatcher;

    constructor (dispatcher = null) {
        this.dispatcher = dispatcher;
    }

    async handle (event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[SUB_MCH_STATE_QUERY]['apiName'], event.params);
        if (res['status'] && res['data']['material'] !== undefined && res['data']['material']) {
            store.dispatch(setSubMerchantMaterialInfo(this.transformer(res['data'])));
        }

        if (res['status']) {
            event['success']({step: this.getStep(res['data']['apply_state'])});
        } else {
            event['failed']();
        }
    }

    async after () {

    }

    getStep (status) {
        switch (status) {
            case FINISHED:
                return SIGNED;
            case NEED_SIGN:
                return WX_PASSED;
            case ACCOUNT_NEED_VERIFY:
                return WX_ACCOUNT_VERIFY;
            case REJECTED:
            case PARAM_ERROR:
                return WX_REFUSED;
            case  AUDITING:
            case CHECKING:
            case  WAIT_SUBMIT:
            case SUBMIT_TO_PLATFORM:
                return SUBMIT_MATERIAL;
            default:
                return CONTRACT_INTERVIEW;
        }
    }

    transformer (result) {
        let hasBusinessLicense = result['material']['business_license_info'] !== undefined && result['material']['business_license_info'];
        let step = this.getStep(result['apply_state']);
        let errors = [];
        if (result['wx_result']['message'] !== undefined && _.isEmpty(result['wx_result']['audit_detail'])) {
            errors.push(result['wx_result']['message'])
        }
        let rejections = {};
        _.each(result['wx_result']['audit_detail'], (item) => {
            if (errors.indexOf(item['reject_reason']) === -1) {
                errors.push(item['reject_reason']);
                rejections[item['param_name']] = item['reject_reason'];
            }
        });
        let bankAddressCode = result['material']['account_info']['bank_address_code'];
        let addressCodes = ['110000', '110100', '110101'];
        if (bankAddressCode) {
            let item0 = _.find(Regions, (item) => {
                if (item.code.substring(0, 2) === bankAddressCode.substring(0, 2)) {
                    return true;
                }
                return false;
            });
            if (item0) {
                addressCodes = [];
                addressCodes.push(item0.code);
                let item1 = _.find(item0.children, (item) => {
                    if (item.code.substring(2, 2) === bankAddressCode.substring(2, 2)) {
                        return true;
                    }
                    return false;
                });
                if (item1) {
                    addressCodes.push(item1.code);
                    let item2 = _.find(item1.children, (item) => {
                        if (item.code.substring(4, 2) === bankAddressCode.substring(4, 2)) {
                            return true;
                        }
                        return false;
                    })

                    if (item2) {
                        addressCodes.push(item2.code);
                    }
                }
            }
        }
        let isOtherBank = (result['material']['account_info']['account_bank'] === undefined || !result['material']['account_info']['account_bank'] || result['material']['account_info']['account_bank'] === '其他银行');
        return {
            status: result['apply_state'],
            step: step,
            maxStep: step,
            requestNo: result['incoming_id'],
            wxRequestNo: result['wx_result']['applyment_id'] !== undefined ? result['wx_result']['applyment_id'] : '',
            merchantShortName: result['merchant_shortname'],
            creatorQRCode: result['wx_result']['sign_url'] !== undefined ? result['wx_result']['sign_url'] : '',
            legalQRCode: result['wx_result']['legal_validation_url'] !== undefined ? result['wx_result']['legal_validation_url'] : '',
            organizationType: parseInt(result['material']['organization_type']),
            ownerRealName: result['material']['id_card_info']['id_card_name'],
            ownerIdCardNumber: result['material']['id_card_info']['id_card_number'],
            ownerIdCardAddress: result['material']['id_card_info']['id_card_address'],
            ownerIdCardValidTimeBegin: result['material']['id_card_info']['id_card_valid_time_begin'],
            ownerIdCardValidTimeEnd: result['material']['id_card_info']['id_card_valid_time'] !== '长期' ? result['material']['id_card_info']['id_card_valid_time'] : null,
            ownerIdCardFrontPhoto: result['material']['id_card_info']['id_card_copy'],
            ownerIdCardBackPhoto: result['material']['id_card_info']['id_card_national'],
            ownerIdCardValidation: result['material']['id_card_info']['id_card_valid_time'] === '长期' ? ID_CARD_VALID_TIME_FOREVER : ID_CARD_VALID_TIME_SHORT,
            companyName: hasBusinessLicense ? result['material']['business_license_info']['merchant_name'] : '',
            businessLicenseNumber: hasBusinessLicense ? result['material']['business_license_info']['business_license_number'] : '',
            businessLicensePhoto: hasBusinessLicense ? result['material']['business_license_info']['business_license_copy'] : '',
            contactorIdCardFrontPhoto: result['material']['contact_info']['contact_id_doc_copy'] !== undefined ? result['material']['contact_info']['contact_id_doc_copy'] : '',
            contactorIdCardBackPhoto: result['material']['contact_info']['contact_id_doc_copy_back'] !== undefined ? result['material']['contact_info']['contact_id_doc_copy_back'] : '',
            contactorIdCardValidation: result['material']['contact_info']['contact_id_doc_period_end'] === '长期' ? ID_CARD_VALID_TIME_FOREVER : ID_CARD_VALID_TIME_SHORT,
            contactorIdCardValidTimeBegin: result['material']['contact_info']['contact_id_doc_period_begin'] !== undefined ? result['material']['contact_info']['contact_id_doc_period_begin'] : '',
            contactorIdCardValidTimeEnd: result['material']['contact_info']['contact_id_doc_period_end'] !== undefined && result['material']['contact_info']['contact_id_doc_period_end'] !== '长期' ? result['material']['contact_info']['contact_id_doc_period_end'] : null,
            contactorAgentLicensePhoto: result['material']['contact_info']['business_authorization_letter'],
            contactorType: parseInt(result['material']['contact_info']['contact_type']),
            contactorRealName: result['material']['contact_info']['contact_name'],
            contactorIdCardNumber: result['material']['contact_info']['contact_id_card_number'],
            contactorMobilePhoneNumber: result['material']['contact_info']['mobile_phone'],
            contactorEmail: result['material']['contact_info']['contact_email'],
            bindBankAccountType: parseInt(result['material']['account_info']['bank_account_type']),
            openAccountName: result['material']['account_info']['account_name'],
            openAccountBank: isOtherBank ? result['material']['account_info']['bank_name'] : result['material']['account_info']['account_bank'],
            bankAccountNumber: result['material']['account_info']['account_number'],
            bankAddressCodes: addressCodes,
            submit: false,
            benefitIsSelf: result['material']['owner'] !== undefined ? result['material']['owner'] : true,
            benefitPersonList: [],
            errors: errors,
            rejections: rejections
        };
    }
}